var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
import { formatNumberWithSeparator } from "@lib/util/numbers-ops";
import EntityPointsIcon from "@modules/shared/logos/entity-points-icon";
import React from "react";
const EntityPointsDisplay = _ref => {
  var _cssModules$globals$p;
  let {
    quantity,
    contrastText = false,
    textClassname,
    iconClassname,
    useShortPointsName = false,
    logoHeight = 18,
    breakOnMobile = false,
    brandClassName,
    showPointsName = true,
    pointNameIconClassName,
    pointsClassName,
    isHeader,
    hideLogo = false
  } = _ref;
  const useNewLayout = isHeader && APP_CONFIGURATION.config.header_row_points_display;
  const {
    cssModules
  } = useCssModules();
  const {
    providerPriceLogo
  } = (_cssModules$globals$p = cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.price) !== null && _cssModules$globals$p !== void 0 ? _cssModules$globals$p : {};
  const defaultProviderPriceLogo = "min-w-6 min-h-6 w-6 h-6";
  return __jsx("span", {
    className: cn("flex items-center text-point_branding", textClassname, {
      'text-white': contrastText,
      'flex-col md:flex-row': breakOnMobile,
      'flex-row': !breakOnMobile
    }, 'inline-flex')
  }, useNewLayout ? __jsx("span", {
    className: "flex flex-row items-center gap-3"
  }, __jsx("span", {
    className: "flex items-center justify-center"
  }, __jsx(EntityPointsIcon, {
    className: cn(providerPriceLogo !== null && providerPriceLogo !== void 0 ? providerPriceLogo : defaultProviderPriceLogo, iconClassname, APP_CONFIGURATION.config.showPointsLogoInPrice && 'block', hideLogo && 'hidden')
  })), __jsx("span", {
    className: "flex flex-col justify-center items-start gap-0"
  }, __jsx("span", {
    className: cn("translate-y-[3px]", pointsClassName)
  }, formatNumberWithSeparator(quantity)), showPointsName && __jsx("span", {
    className: "flex flex-row items-center gap-0 m-0 p-0"
  }, " ", __jsx("span", {
    className: cn("min-w-max", brandClassName, "m-0 p-0 -translate-y-[3px] lowercase")
  }, "".concat(useShortPointsName ? APP_CONFIGURATION.config.pointsCurrencyShort : APP_CONFIGURATION.config.pointsCurrency))))) : __jsx("span", {
    className: cn("flex items-center text-point_branding gap-1", textClassname !== null && textClassname !== void 0 ? textClassname : "tx-psm-semiBold", {
      'text-white': contrastText,
      'flex-col md:flex-row': breakOnMobile,
      'flex-row': !breakOnMobile
    }, 'inline-flex')
  }, __jsx("span", {
    className: cn("inline-flex flex-row items-center gap-1", pointsClassName)
  }, __jsx(EntityPointsIcon, {
    className: cn(providerPriceLogo !== null && providerPriceLogo !== void 0 ? providerPriceLogo : defaultProviderPriceLogo, iconClassname, (!APP_CONFIGURATION.config.showPointsLogoInPrice || hideLogo) && 'hidden')
  }), __jsx("span", {
    className: cn("min-w-max", pointsClassName)
  }, formatNumberWithSeparator(quantity))), showPointsName && __jsx("span", {
    className: "flex flex-row items-center gap-1"
  }, pointNameIconClassName && __jsx(EntityPointsIcon, {
    className: pointNameIconClassName
  }), __jsx("span", {
    className: cn("min-w-max", brandClassName)
  }, "".concat(useShortPointsName ? APP_CONFIGURATION.config.pointsCurrencyShort : APP_CONFIGURATION.config.pointsCurrency)))));
};
export default EntityPointsDisplay;